document.addEventListener("DOMContentLoaded", () => {
  // Image paths for toggling
  const imagePaths = [
    "/assets/images/chevron-down.svg",
    "/assets/images/chevron-up.svg",
  ];

  // Select toggle images
  const toggleImages = {
    resources: document.querySelectorAll(".resource-toggle-image"),
    documentation: document.querySelectorAll(".documentation-toggle-image"),
    updates: document.querySelectorAll(".update-toggle-image"),
  };

  // Function to cycle through images
  const cycleImages = (imagesArray, index) => {
    const image = imagesArray[index];
    const currentIndex = imagePaths.findIndex((path) =>
      image.src.includes(path)
    );
    if (currentIndex !== -1) {
      image.src = imagePaths[(currentIndex + 1) % imagePaths.length];
    }
  };

  // Function to get list items from section
  const getListItems = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (!section) return [];

    const ulElements = Array.from(section.children).filter(
      (child) => child.tagName === "UL"
    );

    return ulElements
      .flatMap((ul) => Array.from(ul.children))
      .map((item) => item.id);
  };

  // Get all list items
  const lists = {
    updates: getListItems("updates"),
    docs: getListItems("docs"),
    resources: getListItems("resources"),
  };

  // Function to add toggle event listeners
  const addToggleListeners = (list, imageType) => {
    list.forEach((element, index) => {
      const title = document.querySelector(`.${element}-title`);
      const background = document.querySelector(`.${element}-bg`);
      const resource = document.querySelector(`.${element}`);

      if (title) {
        title.addEventListener("click", () => {
          resource.classList.toggle("hidden");
          background.classList.toggle("bg-neutral-ghost");
          cycleImages(toggleImages[imageType], index);
        });
      }
    });
  };

  // Add event listeners for each section
  if (lists.updates.length) addToggleListeners(lists.updates, "updates");
  if (lists.docs.length) addToggleListeners(lists.docs, "documentation");
  if (lists.resources.length) addToggleListeners(lists.resources, "resources");
});
